export enum BuySellServiceType {
	Buy = 1,
	Sell = 2
}
